module.exports = __webpack_public_path__ + "img/logo2.113986c0.png";